import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { PartnersTunaService } from "../../../partners-tuna.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'app-partners-account-modal',
    templateUrl: './partners-account-modal.component.html',
    styleUrls: ['./partners-account-modal.component.scss']
})

export class PartnersAccountModalComponent implements OnInit {
    model: any = {};
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<PartnersAccountModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder,
        private partnerService: PartnersTunaService,
        private translateService: TranslateService,
        private toastr: ToastrService
    ) { }
    ngOnInit(): void {

        this.form = this.fb.group({
            name: ['', ''],
            key: [''],
        });

        this.model.open = true;
        this.model.partner = this.data.partner;
        this.model.account = this.data.account;
        this.model.key = this.data.key;
        this.model.partner_obj = this.data.partner_obj;

        this.form = this.fb.group({
            name: ['', ''],
            key: ['', ''],
        });

        this.form.get('key').disable();

    }

    inputFormValidation() {
        this.form.get('name').setValidators([Validators.required]);
        this.form.get('name').updateValueAndValidity();
        this.form.get('key').setValidators([Validators.required]);
        this.form.get('key').updateValueAndValidity();
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }


    focusOutName() {
        var partner_name = this.form.get('name').value;
        this.form.get('key').setValue(this.stringToSlug(partner_name));
    }

    stringToSlug(str) {
        console.log(str);
        str = str.replace(/^\s+|\s+$/g, "");
        str = str.toLowerCase();

        // remove accents
        var from = "àáäâãèéëêìíïîòóöôõùúüûñç·/_,:;";
        var to = "aaaaaeeeeiiiiooooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-"); // collapse dashes

        return str;
    }

    save($event) {
        this.focusOutName();

        console.log('save account');

        this.inputFormValidation();

        if (this.form.valid) {

            var params = {
                partner_key: this.model.partner_obj.key,
                accounts: [{
                    account_key: this.form.get('key').value,
                    account_name: this.form.get('name').value,
                    user_owner_email: this.model.partner_obj.user.username
                }]
            }

            this.partnerService.saveAccount(this.model.partner, this.model.account, params).subscribe(response => {
                this.toastr.success(this.translateService.instant('partners.modal.success'));
                this.dialogRef.close(response);
            },
                (error) => {
                    console.log("error");
                    if (error.result)
                        if (error.result.length > 0) {
                            error.result.forEach(element => {

                                if (element.property == 'SRVPartnerAccountKeyAlreadyExists') {
                                    this.form.get('key')?.enable();
                                }

                                this.toastr.error(element.message);
                            });
                        }
                }

            );
        } else {
            this.validateAllFormFields(this.form);
        }
    }


    close() {
        this.dialogRef.close();
    }

}
